import { SelectChangeEvent } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';

import { RoleType } from '../../../../apollo/__generated__/graphql';
import { useAddRoleMutation } from '../../../../user/hooks/useAddRoleMutation';
import { useRolesQuery } from '../../../../user/hooks/useRolesQuery';

export const useAddRoleDialog = (userId: string, onClose: () => void) => {
  const { data: rolesData } = useRolesQuery();

  const roles = useMemo(
    () => (rolesData?.roles ?? []).map((role) => role.name),
    [rolesData],
  );
  const [role, setRole] = useState<RoleType | null>(null);

  const { addRole } = useAddRoleMutation();

  const onSubmit = () => {
    if (!role) {
      return;
    }
    addRole({
      userId,
      role,
    });
    onClose();
  };

  const onRoleChange = (event: SelectChangeEvent<RoleType>) => {
    setRole(event.target.value as RoleType);
  };

  useEffect(() => {
    if (roles.length > 0) {
      setRole(roles[0]);
    }
  }, [roles]);

  return {
    roles,
    role,
    onSubmit,
    onRoleChange,
  };
};
